export default __webpack_public_path__ + "static/media/Map2-2.dae0dbd6.png";